import { useMutation, useQueryClient } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { productGridKey } from "../products/useGetAllproduct";
import { getProductScoresKey } from "../olapScores/useGetProductScores";

type UpsertPackaging = {
    packaging: PackagingWrite;
};
export const useUpsertPackaging = () => {
    const queryClient = useQueryClient();

    const query = useMutation({
        mutationFn: async (options: UpsertPackaging) => {
            const { packaging } = options;

            const response =
                packaging.id === undefined ?
                    await loggedInApiCall.post("/api/packagings", packaging)
                :   await loggedInApiCall.put("/api/packagings/" + packaging.id, packaging);

            return response;
        },
        onSuccess: (_response, options: UpsertPackaging) => {
            const { id: packagingId } = options.packaging;

            if (packagingId === undefined) return;

            queryClient.invalidateQueries([productGridKey]);
            queryClient.invalidateQueries([getProductScoresKey]);
        },
    });

    return query;
};

export type PackagingShareWrite = {
    organization: IRI;
};

export const toPackagingShareWrites = (organizations: ReadonlyArray<{ "@id": string }>): PackagingShareWrite[] =>
    organizations.map((organization) => ({ organization: organization["@id"] as IRI }));

export type PackagingWrite = {
    id?: number;
    name: string | null | undefined;
    externalId: string | null | undefined;
    weight: number | null | undefined;
    ownedBy?: IRI;
    shares?: PackagingShareWrite[];
    tags?: Record<string, string[]>;
};
